import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import TestimonialTemplate from '@segment/templates/Testimonial'

const Testimonials: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSection variant="noCopy">
      <TestimonialTemplate variant="extended" company="theVintageBar" />
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  max-width: 1260px;
  overflow-x: inherit;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 80px;
      padding-bottom: 80px;
    }
  }
`

export default Testimonials
